import * as yup from "yup";

export const requiredMessage = gettext('This field is required')
export const stringValidator = yup.string().nullable().trim().max(255, gettext('Field must contain less than 255 characters'))
export const textFieldValidator = yup.string().nullable().trim()
export const numberValidator = yup.number().transform((value) => (isNaN(value) ? undefined : value)).nullable()

export function oneOfNumberValidator(object, required = true) {
    if (required === true) {
        return yup.number().typeError(requiredMessage)
            .oneOf(Object.values(object), gettext('Please select one of options above'))
            .required(requiredMessage)
    } else {
        return yup.number().transform((currentValue, originalValue) => {
            return originalValue === 'undefined' ? null : currentValue;
        }).oneOf(Object.values(object), gettext('Please select one of options above')).nullable()
    }
}

export function oneOfStringValidator(object) {
    return stringValidator
        .oneOf(Object.values(object), gettext('Please select one of options above'))
        .required(requiredMessage)
}